/**
 * The one thousands grouper of the client (R687).
 *
 * A figure is a figure in every language, and the group mark is the thin
 * space U+2009 in every language (i18n.md §4). It is never
 * `toLocaleString`: that answers with a comma, a stop or a space by
 * machine, and two players reading one number must read the same number.
 *
 * `state.ts` and `ui/hub/hubstate.ts` both name a grouper of their own;
 * each one calls this. The hub's ladder asks for a plain space, because
 * its column is measured in a monospaced face.
 */

/** The group mark of every figure the client prints. */
export const GROUP_MARK = ' ';

/** A whole number with its thousands grouped. */
export function groupThousands(n: number, sep: string = GROUP_MARK): string {
  const v = Math.round(Number.isFinite(n) ? n : 0);
  const sign = v < 0 ? '-' : '';
  return sign + String(Math.abs(v)).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
}
